/**
 * This is the rsa controller.
 * @memberOf rsa Module
 * @namespace rsa Controller
 */

/**
 * @name rsaController
 * @desc Create the controller.
 * @param $scope
 * @param coreService
 * @memberOf securityquestion Module. rsa Controller
 * @ngInject
 */
function rsaController() {
}

export default rsaController;


// WEBPACK FOOTER //
// ./src/login/securityquestion/rsa/rsa.controller.js